
    <form (formValid)="formValid.set($event)"
          (formDirty)="formDirty.set($event)">

        <div>
            <mat-form-field class="w-full">
                <mat-label>select manufacturer</mat-label>
                <mat-select (selectionChange)="onManufacturerChange($event)">
                    @for (manufacturer of vm.manufacturers; track manufacturer.value) {
                    <mat-option [value]="manufacturer.value">{{manufacturer.label}}</mat-option>
                    }
                </mat-select>
            </mat-form-field>
        </div>

        @if (vm.showRanges) {
        <div>
            <mat-form-field class="w-full">
                <mat-label>select range</mat-label>
                <mat-select (selectionChange)="onRangeChange($event)">
                    @for (range of vm.ranges; track range.value){
                    <mat-option [value]="range.value">{{range.label}}</mat-option>
                    }
                </mat-select>
            </mat-form-field>
        </div> }

        @if (vm.showModules) {
        <div>
            <mat-form-field class="w-full">
                <mat-label>select module</mat-label>
                <mat-select (selectionChange)="onModuleChange($event)">
                    @for (module of vm.modules; track module.value){
                    <mat-option [value]="module.value">{{module.label}}</mat-option>
                    }
                </mat-select>
            </mat-form-field>
        </div> }

    </form>



@if (vm.showDatasheet) { <div [innerHTML]="vm.datasheet" class="view-datasheet-pv">datasheet here..</div> }

@if (vm.showSpinner) {
    <div class="spinner-center spinner-overlay">
        <mat-spinner test-id="spinner"></mat-spinner>
    </div>  }

